import { changeLanguage } from 'i18next';

import type { Locale } from '@/localization/types/localizationTypes';

export const updateLocalizationInstance = (locale: Locale) =>
  changeLanguage(locale, (e) => {
    if (e)
      return console.error(
        '[LOCALIZATION_UTIL]: something went wrong when changing localization',
        e
      );
  });
